(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ros-collection-intro"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ros-live-catalog]').forEach(function(catalog){
  var input=catalog.querySelector('[data-ros-live-search]');
  var cards=Array.from(catalog.querySelectorAll('[data-ros-live-card]'));
  var count=catalog.querySelector('[data-ros-live-count]');
  if(input){
    input.addEventListener('input',function(){
      var query=input.value.trim().toLowerCase();
      var visible=0;
      cards.forEach(function(card){
        var show=!query || (card.getAttribute('data-search')||'').indexOf(query)!==-1;
        card.hidden=!show;
        if(show)visible+=1;
      });
      if(count)count.textContent=String(visible);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
